import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import FocusConsultoria from './pages/FocusConsultoria';
import FocusOrganiza from './pages/FocusOrganiza';
import FocusCoaching from './pages/FocusCoaching';
import FocusPalestras from './pages/FocusPalestras';
import InscricaoBlueSaude from './pages/InscricaoBlueSaude';
import InscricaoDepylExpress from './pages/InscricaoDepylExpress';
import Treinamentos from './pages/Treinamentos';

function App() {
  const [fontSize, setFontSize] = useState('normal');
  const [highContrast, setHighContrast] = useState(false);

  const increaseFontSize = () => {
    if (fontSize === 'normal') setFontSize('large');
    else if (fontSize === 'large') setFontSize('larger');
  };

  const decreaseFontSize = () => {
    if (fontSize === 'larger') setFontSize('large');
    else if (fontSize === 'large') setFontSize('normal');
  };

  const toggleContrast = () => {
    setHighContrast(!highContrast);
  };

  return (
    <Router>
      <div className={`min-h-screen flex flex-col ${
        fontSize === 'large' ? 'large-font' : 
        fontSize === 'larger' ? 'larger-font' : ''
      } ${
        highContrast ? 'high-contrast' : ''
      }`}>
        <Header 
          increaseFontSize={increaseFontSize}
          decreaseFontSize={decreaseFontSize}
          toggleContrast={toggleContrast}
          fontSize={fontSize}
          highContrast={highContrast}
        />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/focus-consultoria" element={<FocusConsultoria />} />
            <Route path="/focus-organiza" element={<FocusOrganiza />} />
            <Route path="/focus-coaching" element={<FocusCoaching />} />
            <Route path="/focus-palestras" element={<FocusPalestras />} />
            <Route path="/inscricao-blue-saude" element={<InscricaoBlueSaude />} />
            <Route path="/inscricao-depyl-express" element={<InscricaoDepylExpress />} />
            <Route path="/treinamentos" element={<Treinamentos />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;